import React, { useState, useEffect } from "react";
import { AffiliateCommissionsData } from "../../../network/api/AffiliateCommissionData";
import Pagination from "../../../../../../../components/Pagination";
import { Link } from "react-router-dom";
import Toast from "../../../../../../../components/Toast";

export default function Earning({ userId, setActiveTab }) {
    const [earnings, setEarnings] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [toastConfig, setToastConfig] = useState({
        visible: false,
        message: "",
        type: "primary",
    });

    const [pageProps, setPageProps] = useState({
        page: 1,
        totalPages: 1,
        totalEntries: 0,
        entryLimit: 0,
        visiblePages: []
    });

    const [pageFilters, setPageFilters] = useState({
        page: null,
        owner: userId,
        limit: 10
    });

    const handlePageChange = (page) => {
        if (page >= 1 && page <= pageProps.totalPages) {
            setPageProps((prev) => ({
                ...prev,
                page: page,
            }));

            setPageFilters((prev) => ({
                ...prev,
                page: page,
            }));
        }

    };

    useEffect(() => {
        const fetchEarningsData = async () => {
            try {
                setIsLoading(true);
                const response = await AffiliateCommissionsData({ pageFilters: pageFilters });
                if (response.status === "success") {
                    setEarnings(response.data.data);
                    setPageProps({
                        page: response.data.page,
                        totalPages: response.data.total_pages,
                        totalEntries: response.data.total_records,
                        entryLimit: response.data.limit,
                        visiblePages: response.data.visible_pages,
                    });
                } else {
                    setToastConfig({
                        visible: true,
                        message: response.message || "Failed to fetch earnings data.",
                        type: "danger",
                    });
                }
            } catch (error) {
                setToastConfig({
                    visible: true,
                    message: "An error occurred while fetching earnings data. Please try again later.",
                    type: "danger",
                });
            }
            setIsLoading(false);
        };

        fetchEarningsData();
    }, [pageFilters]);

    return (
        <div className="row" key={`earnings-${userId}kjhk`}>
            <Toast message={toastConfig.message}
                type={toastConfig.type}
                visible={toastConfig.visible}
                setVisible={(visible) => setToastConfig({ ...toastConfig, visible })}
            />
            {isLoading && (
                <div className="text-center my-5">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            )}
            <div className="col-lg-12">
                <div className="card custom-card">
                    <div className="card-header">
                        <h4 className="card-title">Earnings</h4>
                        
                        <div className="card-options">
                            <button className="btn btn-primary btn-sm" onClick={() => setActiveTab("withdrawals")}>
                                <i className="fa fa-sync me-2"></i> 
                                Withdrawals
                            </button>
                        </div>
                    </div>
                    <div className="card-body">
                        <div id="guestTable-all-1_wrapper" className="table-responsive dataTables_wrapper no-footer ">
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Product</th>
                                        <th>Amount ($)</th>
                                        <th>Role</th>
                                        <th>Description</th>
                                        <th>Transaction Ref</th>
                                        <th>Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {earnings?.length === 0 && (
                                        <tr>
                                            <td colSpan="6" className="text-center py-5">
                                                <div className="d-flex flex-column align-items-center justify-content-center text-muted">
                                                    <i className="fa fa-folder-open fa-3x mb-3"></i>
                                                    <p className="mb-0">No Earnings found</p>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                    {earnings?.map((item, index) => (
                                        <tr key={`earning-${item?.id}`}>
                                            <td>{index + 1}</td>
                                            <td>{item?.product && item?.product?.name ? <Link to={`/shop/${item?.product?.slug}`}>{item?.product?.name} </Link> : "N/A"}</td>
                                            <td>{item?.amount}</td>
                                            <td>{item?.role?.replace('_', ' ')}</td>
                                            <td>{item?.description || "N/A"}</td>
                                            <td>{item?.transaction_reference || "N/A"}</td>
                                            <td>{item?.created_at}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <Pagination
                                pageProps={pageProps}
                                onPageChange={handlePageChange} />

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}